module.exports = __webpack_public_path__ + "static/media/vinos.ff8a49c0.jpg";